// extracted by mini-css-extract-plugin
export var bodySections = "_cb-8";
export var gray = "_cb-7";
export var green = "_cb-4";
export var iconContainer = "_cb-9";
export var iconWidgetContainer = "_cb-1";
export var phoneIcon = "_cb-2";
export var red = "_cb-5";
export var statusDot = "_cb-3";
export var widgetContainer = "_cb-0";
export var yellow = "_cb-6";